(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[868],{

/***/ 3919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7812);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8533);
/* harmony import */ var _shared_Post__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8353);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);









var BlogPosts = function BlogPosts(props) {
  var filter = props.filter;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.data),
      posts = _useState[0],
      setPosts = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      hasMore = _useState2[0],
      setHasMore = _useState2[1];

  if (filter == undefined) {
    filter = '';
  }

  var getMorePost = /*#__PURE__*/function () {
    var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var res, newPosts;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch("https://ergo-platform-cms-nvbpfiue6q-ez.a.run.app" + "/api/posts?sort=date:desc&pagination[withCount]=true&pagination[start]=".concat(posts.length, "&pagination[limit]=9&populate=*&filters[type][$eq]=blog").concat(filter, "&locale=") + props.locale);

            case 2:
              res = _context.sent;
              _context.next = 5;
              return res.json();

            case 5:
              newPosts = _context.sent;
              setPosts(function (post) {
                return [].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(post), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(newPosts.data));
              });

              if (newPosts.meta.pagination.start + newPosts.meta.pagination.limit > newPosts.meta.pagination.total) {
                setHasMore(false);
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getMorePost() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: posts ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      dataLength: posts.length,
      next: getMorePost,
      hasMore: hasMore,
      loader: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "text-center mt-20 mb-8",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h4", {
          children: "Loading..."
        })
      }),
      endMessage: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "text-center mt-20 mb-8",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h4", {
          children: "Nothing more to show"
        })
      }),
      className: "w-full",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "grid grid-cols-1 gap-y-10 md:gap-y-20 md:grid-cols-2 xl:grid-cols-3",
        children: posts.map(function (post) {
          var _post$attributes$imag, _post$attributes$imag2, _post$attributes$imag3, _post$attributes$imag4;

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "mx-auto",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_shared_Post__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              id: post.id,
              title: post.attributes.title,
              subtitle: post.attributes.subtitle,
              author: post.attributes.author,
              tags: post.attributes.tag,
              date: post.attributes.date,
              url: post.attributes.url,
              permalink: post.attributes.permalink,
              type: post.attributes.type,
              content: post.attributes.content,
              image: post.attributes.image.data != null ? (_post$attributes$imag = post.attributes.image.data) === null || _post$attributes$imag === void 0 ? void 0 : (_post$attributes$imag2 = _post$attributes$imag.attributes) === null || _post$attributes$imag2 === void 0 ? void 0 : (_post$attributes$imag3 = _post$attributes$imag2.formats) === null || _post$attributes$imag3 === void 0 ? void 0 : (_post$attributes$imag4 = _post$attributes$imag3.medium) === null || _post$attributes$imag4 === void 0 ? void 0 : _post$attributes$imag4.url : null,
              blogPhoto: post.attributes.blogPhoto,
              authorPhoto: post.attributes.authorPhoto
            }, post.id)
          }, post.id);
        })
      })
    }) : null
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BlogPosts);

/***/ }),

/***/ 8353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Post; }
/* harmony export */ });
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4490);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5742);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);







var removeMd = __webpack_require__(6525);

function Post(_ref) {
  var _removeMd;

  var id = _ref.id,
      title = _ref.title,
      subtitle = _ref.subtitle,
      author = _ref.author,
      date = _ref.date,
      image = _ref.image,
      tags = _ref.tags,
      url = _ref.url,
      type = _ref.type,
      content = _ref.content,
      permalink = _ref.permalink,
      blogPhoto = _ref.blogPhoto,
      authorPhoto = _ref.authorPhoto;
  var hasImage = false;
  var imageUrl = '';

  if (blogPhoto) {
    hasImage = true;
    imageUrl = 'https://storage.googleapis.com/ergo-cms-media' + blogPhoto;
  }

  if (image) {
    hasImage = true;
    imageUrl = image;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: "blog-post flex-shrink-0 shadow-xl rounded-2xl relative z-10 overflow-hidden bg-white dark:bg-white",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "flex-shrink-0 relative",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: type == 'news' ? url : '/blog/' + permalink,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
          className: "block leading-none",
          children: [hasImage == false ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: "post-image-wrap rounded-t-2xl overflow-hidden leading-none",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: "h-48 bg-gray-200 w-full"
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: "post-image-wrap rounded-t-2xl overflow-hidden leading-none",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
              className: "w-full object-cover block",
              src: imageUrl,
              alt: "",
              height: 186,
              width: 384,
              layout: "responsive"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: "absolute left-4 top-4",
            children: tags === null || tags === void 0 ? void 0 : tags.split(',').slice(0, 3).filter(function (word) {
              return word.length > 0;
            }).map(function (item) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/category/".concat(item.trim()),
                passHref: true,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("b", {
                  className: "items-center px-3 py-0.5 rounded-full text-sm font-medium mr-4 bg-brand-black text-white uppercase z-10",
                  children: item.trim()
                }, item.trim())
              }, item.trim());
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "flex-1 p-4 md:p-6 h-72 flex flex-col justify-between rounded-b-2xl",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "flex-1 text-clip",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: type == 'news' ? url : '/blog/' + permalink,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
            className: "block mt-2",
            rel: "noreferrer",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
              className: "font-roboto text-[20px] text-black dark:text-[#807e7e] mb-4",
              children: title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
              className: "font-roboto text-[14px] text-[#585858] dark:text-[#807e7e] mb-0",
              children: type == 'news' ? subtitle : ((_removeMd = removeMd(content)) === null || _removeMd === void 0 ? void 0 : _removeMd.slice(0, 130)) + '...'
            })]
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "mt-4 flex items-center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "flex-shrink-0",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_2__/* .LogoBlack */ .sY, {
            viewBox: "0 0 82 82",
            className: "h-10 w-10"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: "ml-3",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("b", {
            className: "text-[14px] text-black dark:text-white",
            children: author
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: "flex space-x-1",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
              className: "text-[#000000] dark:text-white",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* .FormattedDate */ .Ji, {
                value: date,
                day: "numeric",
                month: "long",
                year: "numeric"
              })
            })
          })]
        })]
      })]
    })]
  });
}

/***/ }),

/***/ 4085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Post; }
/* harmony export */ });
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4490);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9913);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(400);
/* harmony import */ var remark_gfm__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5843);
/* harmony import */ var remark_breaks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1356);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4768);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1226);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5742);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_blog_BlogPosts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3919);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5893);















var __N_SSP = true;
function Post(props) {
  var _props$post$attribute, _props$post$attribute2;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)(),
      locale = _useRouter.locale;

  var hasImage = false;
  var imageUrl = '';

  if (((_props$post$attribute = props.post.attributes.blogPhoto) === null || _props$post$attribute === void 0 ? void 0 : _props$post$attribute.length) > 0) {
    hasImage = true;
    imageUrl = 'https://storage.googleapis.com/ergo-cms-media' + props.post.attributes.blogPhoto;
  }

  if (props.post.attributes.image.data) {
    hasImage = true;
    imageUrl = props.post.attributes.image.data.attributes.url;
  }

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(undefined),
      pageUrl = _useState[0],
      setPageUrl = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function () {
    setPageUrl(window.location.href);
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: "blog-frame-1"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: "blog-frame-2"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: "blog-frame-3"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: "blog-blur-1"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      title: props.post.attributes.title,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: " max-w-[1300px] mx-auto p-4 relative z-10 min-h-[1800px]",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "post bg-white rounded-xl px pt-8 border-[1px] border-gray-300 mt-20 mb-40",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "px-4 md:px-32 md:py-20",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
              className: "-ml-4",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                text: "BACK TO ALL POSTS",
                url: "/blog",
                newTab: false,
                underline: true,
                textColor: "brand-orange",
                background: false
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h1", {
              className: "text-[40px] text-black dark:text-black",
              children: props.post.attributes.title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
              className: "mb-8 mt-4 flex flex-row flex-wrap",
              children: (_props$post$attribute2 = props.post.attributes.tag) === null || _props$post$attribute2 === void 0 ? void 0 : _props$post$attribute2.split(',').filter(function (word) {
                return word.length > 0;
              }).map(function (item) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                  href: "/category/".concat(item.trim()),
                  passHref: true,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                    className: "my-2 cursor-pointer",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("b", {
                      className: "items-center px-3 py-2 rounded-full text-sm font-[12px] mr-4 bg-brand-orange text-white uppercase z-10 tag",
                      children: item.trim()
                    }, item.trim())
                  })
                }, item.trim());
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
              className: "flex",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                className: "flex-shrink-0 mt-1",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_3__/* .LogoBlack */ .sY, {
                  viewBox: "0 0 82 82",
                  className: "h-10 w-10"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                className: "ml-3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("b", {
                  className: "text-[14px] text-black dark:text-black",
                  children: props.post.attributes.author
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                  className: "flex space-x-1",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
                    className: "text-[14px] text-black dark:text-black",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_9__/* .FormattedDate */ .Ji, {
                      value: props.post.attributes.date,
                      day: "numeric",
                      month: "long",
                      year: "numeric"
                    })
                  })
                })]
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
            className: "flex flex-row justify-center md:mx-32",
            children: hasImage == true ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
              src: imageUrl,
              alt: "",
              width: 1200,
              height: 630,
              className: "md:rounded-xl w-full h-auto"
            }) : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "px-4 md:px-32 md:py-20",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
              className: "text-black dark:text-black",
              children: props.post.attributes.subtitle
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_10__/* .ReactMarkdown */ .D, {
              remarkPlugins: [remark_gfm__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, remark_breaks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z],
              rehypePlugins: [rehype_raw__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z],
              className: "blog-md markdown-body",
              children: props.post.attributes.content
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
              className: "mt-10 text-black dark:text-black font-vinila-extended text-[24px]",
              children: "Share post"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
              className: "flex flex-row gap-x-16 pb-10",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                className: "cursor-pointer",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("a", {
                  href: "https://www.facebook.com/sharer/sharer.php?u=".concat(pageUrl),
                  target: "_blank",
                  rel: "noreferrer",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_3__/* .BlogFacebook */ .Jm, {})
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                className: "cursor-pointer",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("a", {
                  href: "https://twitter.com/intent/tweet?text=".concat(pageUrl),
                  target: "_blank",
                  rel: "noreferrer",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_3__/* .BlogX */ .pO, {})
                })
              })]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_blog_BlogPosts__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          data: props.posts,
          locale: locale
        })]
      })
    })]
  });
}

/***/ }),

/***/ 3026:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[id]",
      function () {
        return __webpack_require__(4085);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6525:
/***/ (function(module) {

module.exports = function(md, options) {
  options = options || {};
  options.listUnicodeChar = options.hasOwnProperty('listUnicodeChar') ? options.listUnicodeChar : false;
  options.stripListLeaders = options.hasOwnProperty('stripListLeaders') ? options.stripListLeaders : true;
  options.gfm = options.hasOwnProperty('gfm') ? options.gfm : true;
  options.useImgAltText = options.hasOwnProperty('useImgAltText') ? options.useImgAltText : true;

  var output = md || '';

  // Remove horizontal rules (stripListHeaders conflict with this rule, which is why it has been moved to the top)
  output = output.replace(/^(-\s*?|\*\s*?|_\s*?){3,}\s*$/gm, '');

  try {
    if (options.stripListLeaders) {
      if (options.listUnicodeChar)
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, options.listUnicodeChar + ' $1');
      else
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, '$1');
    }
    if (options.gfm) {
      output = output
        // Header
        .replace(/\n={2,}/g, '\n')
        // Fenced codeblocks
        .replace(/~{3}.*\n/g, '')
        // Strikethrough
        .replace(/~~/g, '')
        // Fenced codeblocks
        .replace(/`{3}.*\n/g, '');
    }
    output = output
      // Remove HTML tags
      .replace(/<[^>]*>/g, '')
      // Remove setext-style headers
      .replace(/^[=\-]{2,}\s*$/g, '')
      // Remove footnotes?
      .replace(/\[\^.+?\](\: .*?$)?/g, '')
      .replace(/\s{0,2}\[.*?\]: .*?$/g, '')
      // Remove images
      .replace(/\!\[(.*?)\][\[\(].*?[\]\)]/g, options.useImgAltText ? '$1' : '')
      // Remove inline links
      .replace(/\[(.*?)\][\[\(].*?[\]\)]/g, '$1')
      // Remove blockquotes
      .replace(/^\s{0,3}>\s?/g, '')
      // Remove reference-style links?
      .replace(/^\s{1,2}\[(.*?)\]: (\S+)( ".*?")?\s*$/g, '')
      // Remove atx-style headers
      .replace(/^(\n)?\s{0,}#{1,6}\s+| {0,}(\n)?\s{0,}#{0,} {0,}(\n)?\s{0,}$/gm, '$1$2$3')
      // Remove emphasis (repeat the line to remove double emphasis)
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      // Remove code blocks
      .replace(/(`{3,})(.*?)\1/gm, '$2')
      // Remove inline code
      .replace(/`(.+?)`/g, '$1')
      // Replace two or more newlines with exactly two? Not entirely sure this belongs here...
      .replace(/\n{2,}/g, '\n\n');
  } catch(e) {
    console.error(e);
    return md;
  }
  return output;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [937,857,43,186,913,774,888,179], function() { return __webpack_exec__(3026); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);